<template>
  <div class="component-content sub-content">
    <div class="list-title no-bottom-border">
      <div class="r">
        <router-link to="/Common/Apply">
          <el-button type="primary" size="mini">通用审批申请</el-button>
        </router-link>
      </div>
      
      <el-row class="item-select">
        <el-col :span="8">
          <label>所属公司：</label>
          <el-select size="mini" :disabled="noSelectOrganization" class="organization-select" v-model="depId"
            placeholder="请选择所属公司">
            <el-option v-for="item in organizationListData" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-col>

        <el-col class="item-input" :span="8">
          <label>搜索：</label>
          <el-input v-model="filterKey" size="mini" placeholder="你可以搜索审批类型/标题/审批发起人"></el-input>
        </el-col>
      </el-row>
    </div>

    <div class="tab-radio-tool">
      <el-radio-group size="mini" v-model="listType">
        <el-radio-button label="0">进行中</el-radio-button>
        <el-radio-button label="1">已审批通过</el-radio-button>
        <el-radio-button label="2">已取消/拒绝</el-radio-button>
      </el-radio-group>
    </div>

    <el-table :data="paginationData" border style="width: 100%" v-loading="loading">
      <el-table-column type="index" label="序号" width="50" align="center">
      </el-table-column>

      <el-table-column label="审批主体">
        <template slot-scope="scope">
          <span
            style="padding:1px 3px;background:#888;color:#fff;border-radius:3px;margin-right:5px;">{{ scope.row.type }}</span>{{ scope.row.title }}
        </template>
      </el-table-column>


      <el-table-column label="审批发起人" width="150px">
        <template slot-scope="scope">
          <user-info :userData='scope.row.flow.creator'></user-info>
        </template>
      </el-table-column>

      <el-table-column label="审批状态" width="100px" align="center">
        <template slot-scope="scope">
          <approval-status :flow="scope.row.flow" :approvals="scope.row.flow.approvals" :status="scope.row.flow.status"></approval-status>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120px">
        <template slot-scope="scope">
          <el-button plain size="mini" @click="projectDetail(scope.row)">详情</el-button>

          <!-- 填表人修改权限 -->
          <span v-if="scope.row.flow.creator.id==userData.id && scope.row.flow.status!='审批通过'">
            <span
              v-if="(scope.row.flow.status == '进行中'||scope.row.flow.status == '已拒绝'||scope.row.flow.status == '已取消')">
              <el-tooltip class="item" effect="dark" content="修改通用审批" placement="bottom">
                <i class="iconfont icon-xiugai meeting-btn-icon mbi-edit"
                  @click="getRouterLink(scope.row.flow.applyId, scope.row.projectId)"></i>
              </el-tooltip>
            </span>
            <el-tooltip v-if="scope.row.flow.status == '进行中'" class="item" effect="dark" content="取消通用审批"
              placement="bottom">
              <i class="iconfont icon-close meeting-btn-icon mbi-remove" @click="cancelFlow(scope.row.flow)"></i>
            </el-tooltip>
          </span>
        </template>
      </el-table-column>

    </el-table>
    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length"
      @current-change="handleCurrentChange">
    </el-pagination>

    <project-info></project-info>

    <!-- 取消流程弹窗 -->
    <div class="pop-room" v-if="cancleStatus">
      <a href="javascript:;" @click="cancleStatus=false" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <el-col :span="22">
          <el-form ref="form" :model="form" label-width="120px" class="form">
            <el-form-item label="取消原因：">
              <el-input size="small" v-model="form.remark" type="textarea" :autosize="{ minRows: 3, maxRows: 6}"
                placeholder="请输入取消审批的原因"></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-button @click="cancelFlowSubmit()" class="form-btn" type="success">确认取消</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </div>

  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import UserInfo from '@/components/UserInfo'
  import ApprovalStatus from '@/components/ApprovalStatus'
  import projectInfo from '@/page/user/projectInfo'
  import Role from '@/Mixins/role'
  export default {
    components: {
      UserInfo,
      projectInfo,
      ApprovalStatus,
    },
    mixins: [Role],
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        organizationListData: [],
        noSelectOrganization: true,
        depId: '',

        // 列表
        loading: true,
        pageSize: 20,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],

        // 筛选搜索
        filterKey: "",

        listType: 0,

        // 取消审批相关
        cancleStatus: false,
        form: {
          flowId: '',
          remark: '',
        },
      }
    },
    created() {

    },
    mounted() {
      this.organizationListData.push({
        id: 0,
        name: "集团所有公司",
        depId: 0
      })
      let _or = this.organization.length > 0 ? this.organization[0].childDepts : []
      this.organizationListData = this.organizationListData.concat(_or)

      this.depId = this.userData.secDepIds.split(",")[0] / 1

      if (this.depId == "7" || this.backRole('SYSTEM_1')) {
        this.noSelectOrganization = false
        this.depId = 0
      }

    },
    methods: {

      // 编辑的链接生成
      getRouterLink(applyId, projectId) {
        this.$router.push({
          path: '/Common/Apply',
          query: {
            applyId: applyId,
          }
        })
      },

      // 取消审批提交
      cancelFlowSubmit() {
        ajax.post('/gc/project/flow/cancel', this.form, (res) => {
          this.$message.success("取消审批成功")
          this.$store.commit('set_projectReload', true)
          this.cancleStatus = false
          this.getLists()
        })
      },
      // 取消审批弹窗
      cancelFlow(flow) {
        this.form.flowId = flow.id
        this.cancleStatus = true
      },

      // 显示审批详情
      projectDetail(row) {
        console.log(row)
        let _projectTable = {
          status: true,
          applyId: row.flow.applyId,
          tableType: row.flow.flowsource,
        }
        this.$store.commit('set_projectTable', _projectTable)
      },
      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选数据
      getFilterData() {
        // console.log(this.filterName)
        if (this.filterKey) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _item = this.listData[i]

            // 筛选搜索结果
            if ((_item.title && _item.title.toLowerCase().indexOf(this.filterKey.toLowerCase()) !=
                -1) || (_item.type && _item.type.toLowerCase().indexOf(this.filterKey.toLowerCase()) !=
                -1) || _item
              .flow
              .creator.name.toLowerCase().indexOf(this.filterKey.toLowerCase()) != -1) {
              this.filterData.push(_item)
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this
          .currentPage)
      },
      // 获取列表
      getLists() {
        this.loading = true
        ajax.post('/flow/common/apply/list', {
          'depId': this.depId == 0 ? "" : this.depId,
          'type': this.listType > 1 ? 1 : this.listType
        }, (res) => {
          this.loading = false
          let _resArr = []

          switch (this.listType) {
            case '1':
              _resArr = res.vo.array.filter((item) => {
                return item.flow.status == '审批通过'
              })
              break;
            case '2':
              _resArr = res.vo.array.filter((item) => {
                return item.flow.status != '审批通过'
              })
              break;
            default:
              _resArr = res.vo.array
              break;
          }

          this.filterData = this.listData = _resArr
          this.getFilterData()
        })
      },
    },
    watch: {
      'depId'() {
        this.currentPage = 1
        this.getLists()
      },
      'filterKey'() {
        this.getFilterData()
      },

      listType() {
        this.currentPage = 1
        this.getLists()
      },
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/common/list.vue